import React from "react";
import { Button } from "semantic-ui-react";
import PdfViewerModal from "./modals/PdfViewerModal";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";

interface Props {
  label: string
  documentNumber: string
  version: number
  documentId: number
}

const ViewDocumentButton = (props: Props) => {
  const [displayPdfPreview, setDisplayPdfPreview] = React.useState(false);

  return <SectionPanel.Panel>
    <div style={{ textAlign: "center" }}>
      <Button
        color="green"
        size="big"
        onClick={() => { setDisplayPdfPreview(true); }}>
        {props.label.toUpperCase()}
      </Button>
    </div>
    <PdfViewerModal
      isOpen={displayPdfPreview}
      onClose={() => { setDisplayPdfPreview(false); }}
      documentId={props.documentId}
      version={props.version}
      documentNumber={props.documentNumber}
    />
  </SectionPanel.Panel>;
};

export default ViewDocumentButton;